const useTimer = () => {
  let timer;
  const start = (...args) => {
    timer = window.setTimeout(...args);
    return timer;
  };
  const clear = () => timer && window.clearTimeout(timer);
  return {
    start,
    clear
  };
};
export {
  useTimer as u
};
//# sourceMappingURL=useTimer-456600be.mjs.map
